/**
 * Get Url Parameter's value
 *
 * @param {String} param Url Parameter to check.
 */
export default function getUrlParam(param = '') {
  if (param.startsWith('#')) {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    return hashParams.get(param.substring(1)) ?? '';
  }

  const windowParams = new URLSearchParams(window.location.search);
  return windowParams.get(param) ?? '';
}
